// Todos os modais do PDV num lugar só.
//
// Eram 295 linhas no meio do `return` de PointOfSale.components.tsx. Nenhum
// deles desenha nada até `currentModalOpen` bater com o seu nome, então o que
// esta camada faz é uma coisa: dizer QUEM abre e o que acontece ao fechar.
import React from "react";
import api from "../../../services/api.service";
import * as AlfredoComponents from "../../../components";

/** O que o ConfirmationModal precisa saber para se desenhar. */
export interface EstadoDaConfirmacao {
  title: string;
  description: string;
  confirmationAction: () => void;
  cancelationAction: () => void;
}

export interface ModaisDoPdvProps {
  /** Nome do modal aberto agora. "" = nenhum. */
  currentModalOpen: string;
  setCurrentModalOpen: React.Dispatch<React.SetStateAction<string>>;
  confirmationModalOpen: EstadoDaConfirmacao;
  setConfirmModalOpen: React.Dispatch<React.SetStateAction<EstadoDaConfirmacao>>;
  modalPosition: { top: number; left: number };
  searchValueInput: string;
  setSearchValueInput: (valor: string) => void;
  searchInputRefType3: React.RefObject<HTMLInputElement>;
  customerInfoByOrder: any;
  setCustomerInfoByOrder: (info: any) => void;
  customerAddressToUpdate: any;
  setCustomerAddressToUpdate: (endereco: any) => void;
  orderDataZustand: any;
  setOrderDataZustand: (dados: any) => void;
  selectedSaleOption: any;
  peopleWithProducts: { key: string; label: string; value: string }[];
  availableDesks: { itemUuid: string; itemName: string; itemOrder: any }[];
  availableCounters: { itemUuid: string; itemName: string; itemOrder: any }[];
  paybackValue: number;
  handlePayback: (payback: number) => void;
  handleSearch: (openNewOrder?: boolean, productExpanded?: boolean) => void;
  handleSetMessage: (message: string, messageType: string) => void;
  getPeriodInfo: () => void;
  setComponent: () => void;
  resetOrderData: () => void;
}

export const ModaisDoPdv: React.FC<ModaisDoPdvProps> = ({
  currentModalOpen,
  setCurrentModalOpen,
  confirmationModalOpen,
  setConfirmModalOpen,
  modalPosition,
  searchValueInput,
  setSearchValueInput,
  searchInputRefType3,
  customerInfoByOrder,
  setCustomerInfoByOrder,
  customerAddressToUpdate,
  setCustomerAddressToUpdate,
  orderDataZustand,
  setOrderDataZustand,
  selectedSaleOption,
  peopleWithProducts,
  availableDesks,
  availableCounters,
  paybackValue,
  handlePayback,
  handleSearch,
  handleSetMessage,
  getPeriodInfo,
  setComponent,
  resetOrderData,
}) => (
  <>
    <AlfredoComponents.AllOptionsModal
      allOptionsOpen={currentModalOpen === "AllOptionsModal"}
      setConfirmModalOpen={setConfirmModalOpen}
      setCurrentModalOpen={setCurrentModalOpen}
      setComponent={setComponent}
      getPeriodInfo={getPeriodInfo}
      modalPosition={modalPosition}
    />
    <AlfredoComponents.ConfirmationModal
      isOpen={currentModalOpen === "ConfirmationModal"}
      title={String(confirmationModalOpen.title)}
      description={String(confirmationModalOpen.description)}
      confirmationAction={confirmationModalOpen.confirmationAction}
      cancelationAction={confirmationModalOpen.cancelationAction}
      onRequestClose={() => {
        setCurrentModalOpen("");
        setConfirmModalOpen({
          title: "",
          description: "",
          confirmationAction: () => { },
          cancelationAction: () => { },
        });
        //handleSearch();
      }}
    />
    <AlfredoComponents.SendToDeliveryModal
      isOpen={currentModalOpen === "sendToDeliveryModal"}
      setSearchValueInput={setSearchValueInput}
      setCustomerInfoByOrder={setCustomerInfoByOrder}
      onRequestClose={() => {
        if (searchInputRefType3.current) {
          searchInputRefType3.current.value = "";
        }
        getPeriodInfo();
        setCurrentModalOpen("");
      }}
    />
    <AlfredoComponents.CustomerModal
      isOpen={currentModalOpen === "CustomerModal"}
      onRequestClose={() => {
        setCurrentModalOpen("");
        getPeriodInfo();
      }}
      setCustomerAddressToUpdate={(customerUuid, customerOrigin, customerName, customerPhone, customerAddress, customerAddressComplement, customerAddressObservation) => setCustomerAddressToUpdate({ customerUuid, customerOrigin, customerName, customerPhone, customerAddress, customerAddressComplement, customerAddressObservation })}
      onCreateAddress={() => setCurrentModalOpen("CreateCustomerAddressModal")}
      onUpdateAddress={() =>
        setCurrentModalOpen("UpdateCustomerAddressModal")
      }
      searchValueInput={searchValueInput.replace("Fone: ", "")}
      setSearchValueInput={setSearchValueInput}
      setCustomerInfoByOrder={setCustomerInfoByOrder}
      searchInputRefType3={searchInputRefType3}
    />
    <AlfredoComponents.CreateCustomerAddressModal
      isOpen={currentModalOpen === "CreateCustomerAddressModal"}
      searchValueInput={searchValueInput.replace("Fone: ", "")}
      onRequestClose={() => {
        setCurrentModalOpen("");
        getPeriodInfo();
      }}
      setSearchValueInput={setSearchValueInput}
      customerInfoByOrder={customerInfoByOrder}
      setCustomerInfoByOrder={setCustomerInfoByOrder}
    />
    <AlfredoComponents.UpdateCustomerAddressModal
      isOpen={currentModalOpen === "UpdateCustomerAddressModal"}
      searchValueInput={searchValueInput.replace("Fone: ", "")}
      onRequestClose={() => {
        setCurrentModalOpen("");
        getPeriodInfo();
      }}
      customerAddressToUpdate={customerAddressToUpdate}
      setSearchValueInput={setSearchValueInput}
      setCustomerInfoByOrder={setCustomerInfoByOrder}
    />
    <AlfredoComponents.PartialWithdrawalModal
      isOpen={currentModalOpen === "PartialWithdrawalModal"}
      onRequestClose={() => {
        setCurrentModalOpen("");
      }}
    />
    <AlfredoComponents.PeriodContentModal
      isOpen={currentModalOpen === "PeriodContentModal"}
      onRequestClose={() => {
        setCurrentModalOpen("");
      }}
    />
    <AlfredoComponents.OpenDeskOrderModal
      desk={searchValueInput}
      isOpen={currentModalOpen === "OrderDeskModal"}
      productsTransfer={orderDataZustand.productsTransfer}
      onRequestClose={(clearField: boolean) => {
        if (clearField) {
          resetOrderData();

          setCurrentModalOpen("");
        }
        else {
          getPeriodInfo();
          handleSearch();
          setCurrentModalOpen("");
        }
      }}
    />
    <AlfredoComponents.OpenCounterOrderModal
      counter={searchValueInput}
      isOpen={currentModalOpen === "OrderCounterModal"}
      productsTransfer={orderDataZustand.productsTransfer}
      onRequestClose={(clearField: boolean) => {
        if (clearField) {
          resetOrderData();

          setCurrentModalOpen("");
        }
        else {
          getPeriodInfo();
          handleSearch();
          setCurrentModalOpen("");
        }
      }}
    />
    <AlfredoComponents.AddProductOrderModal
      isOpen={currentModalOpen === "AddProductModal"}
      onRequestClose={() => {
        handleSearch(false, true);
        setCurrentModalOpen("");
      }}
    />
    <AlfredoComponents.AddObservationModal
      isOpen={currentModalOpen === "AddObservationModal"}
      onRequestClose={() => {
        handleSearch(false, true);
        setCurrentModalOpen("");
      }}
    />
    <AlfredoComponents.PrintOrder
      isOpen={currentModalOpen === "PrintOrder"}
      title={"Imprimir Pedido"}
      description="Selecione um lugar ou a conta inteira."
      items={peopleWithProducts}
      selectedSaleOption={selectedSaleOption}
      confirmationAction={() => {
        try {
          api.post(
            `printOrder/${orderDataZustand.orderUuid}/${selectedSaleOption.itemInfoValue.saleOptionPrinterAddress}`
          );
          api.patch(`/order/${orderDataZustand.orderUuid}`, {
            orderStatus: 5,
          });
          const updatedOrderInfo = orderDataZustand.orderInfo.map((info: any) => {
            if (info.orderInfoType === 14) {
              return {
                ...info,
                orderInfoValue: true,
              };
            }
            return info;
          });

          setOrderDataZustand({
            ...orderDataZustand,
            orderStatus: 5,
            orderInfo: updatedOrderInfo,
          });

          handleSetMessage(`Conta impressa com sucesso!`, `success`);
          setCurrentModalOpen("");
          setConfirmModalOpen({
            title: "",
            description: "",
            confirmationAction: () => { },
            cancelationAction: () => { },
          });
        } catch (error: any) {
          if (error.message === "Network Error") {
            handleSetMessage(
              `Erro ao tentar alterar status da conta, entre em contato com os administradores do Alfredo da sua unidade.`,
              `error`
            );
          } else {
            handleSetMessage(
              `Erro ao alterar status da conta: ${error.message}`,
              `error`
            );
          }
        }
        setCurrentModalOpen("");
      }}
      cancelationAction={() => {
        setCurrentModalOpen("");
      }}
      onRequestClose={() => {
        setCurrentModalOpen("");
      }} />
    <AlfredoComponents.CancelOrderModal
      isOpen={currentModalOpen === "CancelOrderModal"}
      onRequestClose={(clearField?: boolean) => {
        if (clearField) {
          resetOrderData();


          setCurrentModalOpen("");
        }
        else {
          getPeriodInfo();
          handleSearch(false, true);
          setCurrentModalOpen("");
        }
      }}
    />
    <AlfredoComponents.TransferOrderDeskModal
      isOpen={currentModalOpen === "TransferOrderDeskModal"}
      setSearchValueInput={setSearchValueInput}
      onRequestClose={() => {
        handleSearch();
        setCurrentModalOpen("");
      }}
      onNewOrder={() => setCurrentModalOpen("OrderDeskModal")}
      availableDesks={availableDesks}
    />
    <AlfredoComponents.TransferOrderCounterModal
      isOpen={currentModalOpen === "TransferOrderCounterModal"}
      setSearchValueInput={setSearchValueInput}
      onRequestClose={() => {
        handleSearch();
        setCurrentModalOpen("");
      }}
      onNewOrder={() => setCurrentModalOpen("OrderCounterModal")}
      availableCounters={availableCounters}
    />
    <AlfredoComponents.ReviewOrderTaxModal
      isOpen={currentModalOpen === "ReviewOrderTaxModal"}
      onRequestClose={() => {
        handleSearch();
        setCurrentModalOpen("");
      }}
    />
    <AlfredoComponents.ReviewOrderInfoModal
      isOpen={currentModalOpen === "ReviewOrderInfoModal"}
      setSearchValueInput={setSearchValueInput}
      onRequestClose={() => {
        handleSearch();
        setCurrentModalOpen("");
      }}
    />
    <AlfredoComponents.AddPaymentModal
      isOpen={currentModalOpen === "AddPaymentModal"}
      setSearchValueInput={setSearchValueInput}
      onAccountBalance={() => setCurrentModalOpen("AccountBalanceModal")}
      onPayback={(payback: number) => {
        handlePayback(payback);
      }}
      onRequestClose={() => {
        if (searchInputRefType3.current) {
          searchInputRefType3.current.value = "";
        }
        getPeriodInfo();
        setCurrentModalOpen("");
      }}
      setCustomerInfoByOrder={setCustomerInfoByOrder}
    />
    <AlfredoComponents.PaybackModal
      isOpen={currentModalOpen === "PaybackModal"}
      paybackValue={paybackValue}
      setSearchValueInput={setSearchValueInput}
      setCustomerInfoByOrder={setCustomerInfoByOrder}
      onRequestClose={() => {
        getPeriodInfo();
        setCurrentModalOpen("");
      }}
    />
    <AlfredoComponents.AccountBalanceModal
      isOpen={currentModalOpen === "AccountBalanceModal"}
      onRequestClose={async () => {
        await handleSearch();
        setCurrentModalOpen("AddPaymentModal");
      }}
    />
    <AlfredoComponents.PeriodOrdersModal
      isOpen={currentModalOpen === "PeriodOrdersModal"}
      onRequestClose={() => {
        setCurrentModalOpen("");
      }}
      saleType={Number(selectedSaleOption.itemInfoValue.saleOptionType)}
    />
    <AlfredoComponents.AddDiscountModal
      isOpen={currentModalOpen === "AddDiscountModal"}
      onRequestClose={() => {
        handleSearch();
        setCurrentModalOpen("");
      }}
      orderTotal={parseFloat(
        (orderDataZustand?.totals?.totalProductsPrice || "0").replace(",", ".")
      )}
    />
  </>
);
